export function VehicleAdvertisingCtrl (
  $scope, 
  $window, 
  $translate, 
  $state, 
  gridAPI, 
  sessionObjAPI, 
  workshopAPI, 
  messages, 
  confirm
) {
  $scope.saveCarSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'carsales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CAR_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CAR_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CAR_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CAR_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveBikeSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'bikesales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BIKE_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BIKE_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BIKE_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BIKE_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveBoatSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'boatsales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BOAT_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BOAT_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BOAT_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.BOAT_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveTruckSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'trucksales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.TRUCK_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.TRUCK_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.TRUCK_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.TRUCK_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveConstructionSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'constructionsales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CONSTRUCTION_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CONSTRUCTION_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CONSTRUCTION_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CONSTRUCTION_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveFarmMachinerySales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'farmmachinerysales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.FARM_MACHINERY_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.FARM_MACHINERY_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.FARM_MACHINERY_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.FARM_MACHINERY_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.saveCaravanCampingSales = function (change) {
    workshopAPI.patch('/dealership_advertising_vehicle', $scope.advertising, 'dealership_advertising_vehicle')
     .then(function () {
        $state.reload();
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        var details = {
          advertising_type : 'caravancampingsales',
          advertising: $scope.advertising
        }
        if (change == true) {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CARAVAN_CAMPING_SALES')}))
            .then(function () {
              return workshopAPI.patch('/vehicle_attachment/advertise_all_vehicle_attachments', details, 'vehicle_attachment');
            }).then (function (result) {
              if (result) {
                $state.reload();
                messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CARAVAN_CAMPING_SALES')}), 'success');
              };   
            }, function (err) {
              messages.error(err);
            });
        }
        else {
          confirm.generic($translate.instant('JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CARAVAN_CAMPING_SALES')})).then(function() {
            return workshopAPI.patch('/vehicle_attachment/remove_advertising_from_vehicle_attachments', details, 'vehicle_attachment');
          }).then(function(result) {
            if (result) {
              $state.reload();
              messages.show($translate.instant('JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {name: $translate.instant('DEALERSHIP_SPACE.ADVERTISING.CARAVAN_CAMPING_SALES')}), 'success');
            };
          })
        };
      }, function (err) {
        messages.error(err);
      });
  };
};